import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-vision-realization',
  templateUrl: './vision-realization.component.html',
  styleUrls: ['./vision-realization.component.scss']
})
export class VisionRealizationComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Vision Realization');
  }

}
